(function () {
  'use strict';

  if (window.whiteOakCartErrorsInstalled) return;
  window.whiteOakCartErrorsInstalled = true;

  var lastMessage = '';
  var lastShownAt = 0;
  var previouslyFocusedElement = null;

  function installPopupStyles() {
    if (document.getElementById('WhiteOakCartErrorStyles')) return;

    var style = document.createElement('style');
    style.id = 'WhiteOakCartErrorStyles';
    style.textContent = `
      .wop-cart-error[hidden] {
        display: none !important;
      }

      .wop-cart-error {
        position: fixed;
        inset: 0;
        z-index: 2147483000;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 20px;
        font-family: var(--typeBasePrimary, Questrial, sans-serif);
      }

      .wop-cart-error__backdrop {
        position: absolute;
        inset: 0;
        background: rgba(15, 15, 15, 0.68);
        opacity: 0;
        transition: opacity 200ms ease;
      }

      .wop-cart-error__dialog {
        position: relative;
        width: min(100%, 520px);
        padding: 46px 42px 40px;
        background: var(--colorBody, #fff);
        color: var(--colorTextBody, #000);
        border-top: 6px solid #135506;
        box-shadow: 0 22px 70px rgba(0, 0, 0, 0.3);
        text-align: center;
        opacity: 0;
        transform: translateY(16px) scale(0.98);
        transition: opacity 200ms ease, transform 200ms ease;
      }

      .wop-cart-error.is-visible .wop-cart-error__backdrop {
        opacity: 1;
      }

      .wop-cart-error.is-visible .wop-cart-error__dialog {
        opacity: 1;
        transform: translateY(0) scale(1);
      }

      .wop-cart-error__close {
        position: absolute;
        top: 8px;
        right: 12px;
        width: 44px;
        height: 44px;
        padding: 0;
        border: 0;
        background: transparent;
        color: #000;
        font: inherit;
        font-size: 34px;
        line-height: 1;
        cursor: pointer;
      }

      .wop-cart-error__close:hover,
      .wop-cart-error__close:focus {
        color: #135506;
      }

      .wop-cart-error__eyebrow {
        margin: 0 0 12px;
        color: #135506;
        font-size: 12px;
        line-height: 1.4;
        letter-spacing: 0.18em;
      }

      .wop-cart-error__title {
        margin: 0 0 18px;
        font-family: var(--typeHeaderPrimary, Questrial, sans-serif);
        font-size: clamp(28px, 5vw, 38px);
        font-weight: 400;
        line-height: 1.1;
        text-transform: none;
      }

      .wop-cart-error__message {
        margin: 0 auto 28px;
        max-width: 420px;
        font-size: 18px;
        line-height: 1.55;
      }

      .wop-cart-error__button {
        min-width: 210px;
        margin: 0;
        padding: 13px 24px;
        border: 0;
        border-radius: 0;
        background: var(--colorBtnPrimary, #111);
        color: var(--colorBtnPrimaryText, #fff);
        font: inherit;
        font-size: 14px;
        letter-spacing: 0.08em;
        text-transform: uppercase;
        cursor: pointer;
      }

      .wop-cart-error__button:hover,
      .wop-cart-error__button:focus {
        background: #135506;
        color: #fff;
      }

      .wop-cart-error__dialog:focus {
        outline: none;
      }

      .wop-cart-error__close:focus-visible,
      .wop-cart-error__button:focus-visible {
        outline: 2px solid #135506;
        outline-offset: 3px;
      }

      .wop-cart-error-open {
        overflow: hidden;
      }

      @media only screen and (max-width: 600px) {
        .wop-cart-error {
          align-items: flex-end;
          padding: 12px;
        }

        .wop-cart-error__dialog {
          width: 100%;
          padding: 42px 24px 30px;
        }

        .wop-cart-error__button {
          width: 100%;
        }
      }

      @media (prefers-reduced-motion: reduce) {
        .wop-cart-error__backdrop,
        .wop-cart-error__dialog {
          transition: none;
        }
      }
    `;

    document.head.appendChild(style);
  }

  function isCartRequest(url) {
    try {
      var pathname = new URL(url, window.location.origin).pathname;

      return /\/cart\/(?:add|change|update)(?:\.js)?$/.test(pathname);
    } catch (error) {
      return false;
    }
  }

  function getErrorMessage(data) {
    if (!data) return '';

    if (typeof data === 'string') {
      try {
        return getErrorMessage(JSON.parse(data));
      } catch (error) {
        return data;
      }
    }

    if (typeof data.description === 'string') {
      return data.description;
    }

    if (data.description && typeof data.description === 'object') {
      var description = Object.values(data.description)[0];

      if (Array.isArray(description)) {
        return description[0] || '';
      }

      if (description) {
        return String(description);
      }
    }

    if (Array.isArray(data.errors)) {
      var firstError = data.errors[0];

      if (typeof firstError === 'string') {
        return firstError;
      }

      if (firstError && firstError.message) {
        return firstError.message;
      }
    }

    if (typeof data.errors === 'string') {
      return data.errors;
    }

    if (data.errors && typeof data.errors === 'object') {
      var errorValue = Object.values(data.errors)[0];

      if (Array.isArray(errorValue)) {
        return errorValue[0] || '';
      }

      if (errorValue) {
        return String(errorValue);
      }
    }

    if (
      typeof data.message === 'string' &&
      data.message !== 'Cart Error'
    ) {
      return data.message;
    }

    return '';
  }

  function ensurePopup() {
    if (document.getElementById('WhiteOakCartError')) return;

    var popup = document.createElement('div');
    popup.id = 'WhiteOakCartError';
    popup.className = 'wop-cart-error';
    popup.hidden = true;

    var backdrop = document.createElement('div');
    backdrop.className = 'wop-cart-error__backdrop';
    backdrop.setAttribute('data-wop-close', '');

    var dialog = document.createElement('div');
    dialog.className = 'wop-cart-error__dialog';
    dialog.setAttribute('role', 'alertdialog');
    dialog.setAttribute('aria-modal', 'true');
    dialog.setAttribute('aria-labelledby', 'WhiteOakCartErrorTitle');
    dialog.setAttribute('aria-describedby', 'WhiteOakCartErrorMessage');
    dialog.setAttribute('tabindex', '-1');

    var closeButton = document.createElement('button');
    closeButton.type = 'button';
    closeButton.className = 'wop-cart-error__close';
    closeButton.setAttribute('aria-label', 'Close message');
    closeButton.setAttribute('data-wop-close', '');
    closeButton.textContent = '×';

    var eyebrow = document.createElement('p');
    eyebrow.className = 'wop-cart-error__eyebrow';
    eyebrow.textContent = 'WHITE OAK PASTURES';

    var title = document.createElement('h2');
    title.id = 'WhiteOakCartErrorTitle';
    title.className = 'wop-cart-error__title';
    title.textContent = 'Please update your cart';

    var message = document.createElement('p');
    message.id = 'WhiteOakCartErrorMessage';
    message.className = 'wop-cart-error__message';

    var confirmButton = document.createElement('button');
    confirmButton.type = 'button';
    confirmButton.className = 'wop-cart-error__button';
    confirmButton.setAttribute('data-wop-close', '');
    confirmButton.textContent = 'Continue shopping';

    dialog.appendChild(closeButton);
    dialog.appendChild(eyebrow);
    dialog.appendChild(title);
    dialog.appendChild(message);
    dialog.appendChild(confirmButton);

    popup.appendChild(backdrop);
    popup.appendChild(dialog);
    document.body.appendChild(popup);

    popup.addEventListener('click', function (event) {
      if (
        event.target instanceof Element &&
        event.target.hasAttribute('data-wop-close')
      ) {
        closePopup();
      }
    });

    popup.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        closePopup();
        return;
      }

      if (event.key !== 'Tab') return;

      var controls = popup.querySelectorAll(
        'button:not([disabled]), [href], [tabindex]:not([tabindex="-1"])'
      );

      if (!controls.length) return;

      var firstControl = controls[0];
      var lastControl = controls[controls.length - 1];

      if (
        event.shiftKey &&
        document.activeElement === firstControl
      ) {
        event.preventDefault();
        lastControl.focus();
      } else if (
        !event.shiftKey &&
        document.activeElement === lastControl
      ) {
        event.preventDefault();
        firstControl.focus();
      }
    });
  }

  function showPopup(message) {
    message = String(message || '').trim();

    if (!message) {
      message = 'We could not update your cart. Please try again.';
    }

    var now = Date.now();

    if (
      message === lastMessage &&
      now - lastShownAt < 1000
    ) {
      return;
    }

    lastMessage = message;
    lastShownAt = now;

    ensurePopup();

    var popup = document.getElementById('WhiteOakCartError');
    var messageElement = document.getElementById(
      'WhiteOakCartErrorMessage'
    );
    var dialog = popup.querySelector('.wop-cart-error__dialog');

    previouslyFocusedElement = document.activeElement;
    messageElement.textContent = message;

    popup.hidden = false;
    document.documentElement.classList.add('wop-cart-error-open');

    window.requestAnimationFrame(function () {
      popup.classList.add('is-visible');
      dialog.focus();
    });
  }

  function closePopup() {
    var popup = document.getElementById('WhiteOakCartError');

    if (!popup || popup.hidden) return;

    popup.classList.remove('is-visible');
    document.documentElement.classList.remove(
      'wop-cart-error-open'
    );

    window.setTimeout(function () {
      popup.hidden = true;

      if (
        previouslyFocusedElement &&
        document.documentElement.contains(previouslyFocusedElement)
      ) {
        previouslyFocusedElement.focus();
      }
    }, 200);
  }

  function reportFetchError(response) {
    if (
      response.status !== 422 ||
      !isCartRequest(response.url)
    ) {
      return;
    }

    response
      .clone()
      .json()
      .then(function (data) {
        showPopup(getErrorMessage(data));
      })
      .catch(function () {
        response
          .clone()
          .text()
          .then(function (text) {
            showPopup(getErrorMessage(text));
          })
          .catch(function () {
            showPopup('');
          });
      });
  }

  installPopupStyles();

  if (window.fetch) {
    var originalFetch = window.fetch;

    window.fetch = function () {
      return originalFetch
        .apply(this, arguments)
        .then(function (response) {
          reportFetchError(response);
          return response;
        });
    };
  }

  var originalXhrOpen = XMLHttpRequest.prototype.open;

  XMLHttpRequest.prototype.open = function (method, url) {
    this.addEventListener('load', function () {
      if (
        this.status !== 422 ||
        !isCartRequest(url || this.responseURL)
      ) {
        return;
      }

      showPopup(getErrorMessage(this.responseText));
    });

    return originalXhrOpen.apply(this, arguments);
  };
})();